import React, { useState } from 'react';
import { Send, X, MessageSquare } from 'lucide-react';
import './ChatBar.css';

const QUICK_ACTIONS = [
    'Analyze my deal',
    'How to improve?',
    'Offer scenarios',
];

const ChatBar = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [message, setMessage] = useState('');
    const [messages, setMessages] = useState([]);

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!message.trim()) return;
        setMessages(prev => [
            ...prev,
            { role: 'user', text: message.trim() },
            { role: 'assistant', text: 'AI analysis coming soon. This feature is under development.' },
        ]);
        setMessage('');
    };

    const handleQuickAction = (action) => {
        setMessages(prev => [
            ...prev,
            { role: 'user', text: action },
            { role: 'assistant', text: 'AI analysis coming soon. This feature is under development.' },
        ]);
    };

    return (
        <>
            {/* Floating trigger button */}
            {!isOpen && (
                <button
                    className="chat-fab"
                    onClick={() => setIsOpen(true)}
                    aria-label="Open Deal Advisor"
                >
                    <MessageSquare size={22} />
                </button>
            )}

            {/* Slide-out panel */}
            {isOpen && (
                <div className="chat-panel">
                    {/* Header */}
                    <div className="chat-panel-header">
                        <div className="chat-panel-header-info">
                            <div className="chat-panel-avatar">
                                <MessageSquare size={18} />
                            </div>
                            <div>
                                <div className="chat-panel-title">Deal Advisor</div>
                                <div className="chat-panel-subtitle">AI Investment Analysis</div>
                            </div>
                        </div>
                        <button
                            className="chat-panel-close"
                            onClick={() => setIsOpen(false)}
                            aria-label="Close"
                        >
                            <X size={18} />
                        </button>
                    </div>

                    {/* Messages area */}
                    <div className="chat-panel-messages">
                        {/* Welcome message (always shown) */}
                        <div className="chat-msg assistant">
                            <div className="chat-msg-avatar">
                                <MessageSquare size={14} />
                            </div>
                            <div className="chat-msg-bubble">
                                <strong>I'm your Deal Coach!</strong>
                                <p>I can analyze your current deal, suggest improvements, create offer scenarios, and answer any real estate investment questions.</p>
                            </div>
                        </div>

                        {/* Quick action chips (shown when no user messages yet) */}
                        {messages.length === 0 && (
                            <div className="chat-quick-actions">
                                {QUICK_ACTIONS.map(action => (
                                    <button
                                        key={action}
                                        className="chat-chip"
                                        onClick={() => handleQuickAction(action)}
                                    >
                                        {action}
                                    </button>
                                ))}
                            </div>
                        )}

                        {/* Conversation */}
                        {messages.map((msg, i) => (
                            <div key={i} className={`chat-msg ${msg.role}`}>
                                {msg.role === 'assistant' && (
                                    <div className="chat-msg-avatar">
                                        <MessageSquare size={14} />
                                    </div>
                                )}
                                <div className="chat-msg-bubble">{msg.text}</div>
                            </div>
                        ))}
                    </div>

                    {/* Input */}
                    <form className="chat-panel-input" onSubmit={handleSubmit}>
                        <input
                            type="text"
                            placeholder="Ask about your deal..."
                            value={message}
                            onChange={e => setMessage(e.target.value)}
                        />
                        <button type="submit" disabled={!message.trim()}>
                            <Send size={16} />
                        </button>
                    </form>
                </div>
            )}
        </>
    );
};

export default ChatBar;
